import { useFlag } from '@/components/posthog-provider';
import { useActiveOrganization } from '@/features/organization';
import { EXTERNAL_CONSENT_FORMS_FLAG } from '@borradh-workspace/labels';
import { sendsToBorradhBookingPage } from '@borradh-workspace/web-shared';

/** Consent forms follow the clinic's existing booking setup. */
export function useConsentFormMode() {
  const enabled = useFlag(EXTERNAL_CONSENT_FORMS_FLAG);
  const { data: organization, isPending } = useActiveOrganization();
  return {
    isExternal: !!(
      enabled &&
      organization &&
      !sendsToBorradhBookingPage({
        ...organization,
        defaultBookingLink: organization.defaultBookingLink ?? null,
      })
    ),
    isPending: isPending || !organization,
  };
}
